import { ConnectionManagerNetworks, ConnectionManagerNetworkKeys } from '../../helpers/constants';
import getConnectionsByNetwork from './getConnectionsByNetwork';
import { getBaseAccessesUrlByNetwork } from './getBaseUrlByNetwork';
import networkConnectionNormalizer from '../../normalizers/networkConnection';

const pathMapByNetwork = {
  [ConnectionManagerNetworkKeys.PIGEON_HOLE]: '_embedded.pigeonholeAccesses',
};

const supportedNetworks = Object.values(ConnectionManagerNetworks)
  .filter(({ isSupported }) => isSupported)
  .map(({ type }) => type);

export default async function getAllConnections({ APIBaseURL, accountId }) {
  const promises = supportedNetworks.map((networkType) => {
    const baseUrl = getBaseAccessesUrlByNetwork(APIBaseURL, networkType);
    const url = `${baseUrl}/search/by-account?id=${accountId}`;

    const networkObj = ConnectionManagerNetworks[networkType];
    const normalizerFunc = networkConnectionNormalizer(networkObj);
    const responseDataObjPath = pathMapByNetwork[networkType];

    return getConnectionsByNetwork(url, normalizerFunc, responseDataObjPath);
  });

  const allConnection = await Promise.all(promises);
  return allConnection.flat();
}
